<template>
  <transition
    name="modal-fade"
    @after-leave="$emit('afterLeave')"
  >
    <div class="v-backdrop" @click.self="$emit('close')">
      <div class="v-modal">
        <div class="v-header">
          <span class="v-close" @click="$emit('close')">
          </span>
        </div>
        <div class="v-body">
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
}
</script>

<style lang="scss" scoped>
.v-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  z-index: 100000;
}

.v-modal {
  background: #fff;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  max-width: 700px;
  box-shadow:
    0 0.2px 0.9px rgba(0, 0, 0, 0.035),
    0 0.6px 2.1px rgba(0, 0, 0, 0.048),
    0 1.3px 3.9px rgba(0, 0, 0, 0.059),
    0 2.6px 6.9px rgba(0, 0, 0, 0.071),
    0 5.7px 13px rgba(0, 0, 0, 0.087),
    0 14px 31px rgba(0, 0, 0, 0.13)
  ;
  @media screen and (min-width: 900px) {
    width: 700px;
    border-radius: 16px;
  }
}

.v-header {
  display: flex;
  justify-content: flex-end;
}

.v-close {
  cursor: pointer;
  position: relative;
  width: 45px;
  height: 45px;

  @media screen and (min-width: 900px) {
    transform: scale(1.5);
    transform-origin: 100% 0;
  }

  &:active,
  &:hover {
    opacity: .5
  }

  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 18px;
    background: #333;
    border-radius: 2px;
    top: 0;
    bottom: 0;
    margin: auto;
    transition: var(--animation-duration) var(--animation-easing);
    right: 0;
    left: 0;
    height: 1px;
  }

  &::before {
    bottom: 10px;
    transform: translateY(5px) rotate(45deg);
  }

  &::after {
    top: 10px;
    transform: translateY(-5px) rotate(-45deg);
  }
}

.v-body {
  padding: 0 20px 20px;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity .5s ease;
}
</style>
